module.exports = __webpack_public_path__ + "img/roadmap.eb5db8fa.jpg";